/**
 * Custom Audio Player Control
 * Ensures only one audio player plays at a time across the page
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get all audio elements on the page
  const audioElements = document.querySelectorAll('audio');
  
  // Add event listener to each audio element
  audioElements.forEach(audio => {
    audio.addEventListener('play', function() {
      // Pause all other audio elements when this one starts playing
      audioElements.forEach(otherAudio => {
        if (otherAudio !== audio) {
          otherAudio.pause();
        }
      });
    });
  });
});